import _defineProperty from "/vercel/workpath0/.yarn/cache/@babel-runtime-npm-7.12.5-b3edb8ee8e-423fb00793.zip/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import styled from 'styled-components';
import { maxWidth } from 'styled-system';
import PropTypes from 'prop-types';
import { TYPOGRAPHY, COMMON } from './constants';
import theme from './theme';
import sx from './sx';
var Truncate = styled('div').withConfig({
  displayName: "Truncate",
  componentId: "sc-1b0dcmo-0"
})(["", " ", " display:", ";overflow:hidden;text-overflow:ellipsis;vertical-align:", ";white-space:nowrap;", " ", " ", ";"], TYPOGRAPHY, COMMON, function (props) {
  return props.inline ? 'inline-block' : 'inherit';
}, function (props) {
  return props.inline ? 'top' : 'initial';
}, maxWidth, function (props) {
  return props.expandable ? "&:hover { max-width: 10000px; }" : '';
}, sx);
Truncate.defaultProps = {
  as: 'div',
  expandable: false,
  inline: false,
  maxWidth: 125,
  theme: theme
};
Truncate.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, TYPOGRAPHY.propTypes), COMMON.propTypes), {}, {
  expandable: PropTypes.bool,
  inline: PropTypes.bool
}, sx.propTypes), {}, {
  maxWidth: PropTypes.number,
  theme: PropTypes.object,
  title: PropTypes.string.isRequired
});
export default Truncate;